import { z } from 'zod';

/**
 * What finalize accepts — almost nothing, on purpose.
 *
 * Every fact about the object (its real size, its real type, its dimensions, its
 * blur placeholder) is read from the **bytes the server fetched**, never from
 * the caller: the client already told us what it intended to upload at presign
 * time, and finalize exists precisely to check that claim rather than record a
 * second one. `sortOrder` is the one genuine caller decision, and only for a
 * kind a member holds several of.
 *
 * The response is a `MediaAsset`.
 */
export const FinalizeUploadRequestSchema = z
  .object({
    sortOrder: z.number().int().nonnegative().optional(),
  })
  .strict();

export type FinalizeUploadRequest = z.infer<typeof FinalizeUploadRequestSchema>;
